const state = {
  currentVariantId: null,
  purchaseType: "",
  sellingPlans: [],
  sellingPlan: {},
};

const mutations = {
  SELECT_VARIANT(state, variantId) {
    state.currentVariantId = variantId;
  },
  SET_PURCHASE_TYPE: (state, payload) => {
    state.purchaseType = payload;
  },
  SET_SELLING_PLANS: (state, payload) => {
    state.sellingPlans = payload;
  },
  SET_SELLING_PLAN: (state, payload) => {
    state.sellingPlan = payload;
  },
};

const actions = {
  selectVariant({ commit }, variantId) {
    commit("SELECT_VARIANT", variantId);
  },
  setPurchaseType: ({ commit }, payload) => {
    commit("SET_PURCHASE_TYPE", payload);
  },
  setSellingPlans: ({ commit, state }, payload) => {
    commit("SET_SELLING_PLANS", payload);

    // Set default plan based on theme settings
    if (Object.keys(state.sellingPlan).length === 0) {
      const presetPlanNumber = window.BVA.settings.subscription_shipping_interval_preset || false;
      const presetPlanIndex = presetPlanNumber ? presetPlanNumber - 1 : 0;
      commit("SET_SELLING_PLAN", payload[presetPlanIndex]);
    }
  },
  setSellingPlan: ({ commit }, payload) => {
    commit("SET_SELLING_PLAN", payload);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
